import React, { useContext, useEffect, useState } from 'react'
import DatePickerC from '../../../formFields/DatePicker'
import { useTranslation } from 'react-i18next'
import { handleDate } from '../../../../utils'
import { DomainContext } from '../../../../context/DomainContext'

const DatePickerSearch= ({ Header, isMulti, className ,accessor, probName }) => {

    const [dates, setDates] = useState()

    const { setCustomSearchData, customSearchData, clearField } = useContext(DomainContext)

    const { t } = useTranslation()

    useEffect(() => {
        let searchObjectValues = customSearchData;

        if (!isMulti) {
            searchObjectValues[probName || accessor] = handleDate(dates)
        } else {
            searchObjectValues[`${probName || accessor}From`] = handleDate(dates?.from)
            searchObjectValues[`${probName || accessor}To`] = handleDate(dates?.to)
        }

        setCustomSearchData((prev) => searchObjectValues)

    }, [dates])

    useEffect(() => {
        setDates(null)
    }, [clearField])

    return (
        <>
            <DatePickerC className={className} Apply={setDates} dates={dates} isSingle={!isMulti} placeholder={t(Header) || ''} />
        </>
    )
}

export default DatePickerSearch